/* eslint-disable @typescript-eslint/no-explicit-any */
import * as types from "../../actionTypes/Dashboard/eurailPassActionTypes";

export const eurailPassCountriesAction = {
  STARTED: (args: any) => ({
    type: types.EURAIL_PASS_COUNTRIES.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.EURAIL_PASS_COUNTRIES.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.EURAIL_PASS_COUNTRIES.REJECTED }),
};

export const eurailPassSearchAction = {
  STARTED: (args: any) => ({
    type: types.EURAIL_PASS_SEARCH.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.EURAIL_PASS_SEARCH.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.EURAIL_PASS_SEARCH.REJECTED }),
};

export const getEurailPassListAction = {
  STARTED: (args: any) => ({
    type: types.GET_EURAIL_PASS_LIST.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_EURAIL_PASS_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_EURAIL_PASS_LIST.REJECTED }),
};

export const eurailPassPreBookAction = {
  STARTED: (args: any) => ({
    type: types.EURAIL_PASS_PRE_BOOK.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.EURAIL_PASS_PRE_BOOK.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.EURAIL_PASS_PRE_BOOK.REJECTED }),
};

export const eurailPassCheckoutAction = {
  STARTED: (args: any) => ({
    type: types.EURAIL_PASS_CHECKOUT.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.EURAIL_PASS_CHECKOUT.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.EURAIL_PASS_CHECKOUT.REJECTED }),
};
